import {
  allCarListModalAtom,
  allDestListModalAtom,
  allNotAssignListModalAtom,
  allOrderListModalAtom,
  basicInfoAtom,
  resultDestListAtom,
  selectedCarListAtom,
  shippingListCollapseAtom,
  timeLineAtom,
  timeLineChgArrAtom,
} from '@/commons/constants';
import { Button } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import styled from 'styled-components';

import { useEffect, useState } from 'react';
import * as _ from 'lodash';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';

import { TimeLine } from '@/types/result';

const MainWrap = styled.div<{ calWidth: string; topOffset: string; timelineOpen: boolean }>`
  position: absolute;
  // border: 1px solid red;
  top: ${({ topOffset }) => topOffset};
  ${({ timelineOpen, calWidth }) => timelineOpen
    ? `right: 1rem;`
    : `left: calc(2rem + ${calWidth}); width: calc(100% - 1.6rem - 2rem - 10rem - ${calWidth});`
  }
  display: flex;
  align-items: ${({ timelineOpen }) => timelineOpen ? 'flex-end' : 'center'};
  flex-direction: ${({ timelineOpen }) => timelineOpen ? 'column' : 'row'};
  flex-wrap: wrap;
  gap: 1rem;
  transition: all 0.3s ease-in-out;
`;

export default function BasicInfo() {
  const basicInfo = useAtomValue(basicInfoAtom);

  const timeLine = useAtomValue(timeLineAtom);
  const shippingListCollapse = useAtomValue(shippingListCollapseAtom);

  const setAllCarListModal = useSetAtom(allCarListModalAtom);
  const setAllDestListModal = useSetAtom(allDestListModalAtom);
  const setAllOrderListModal = useSetAtom(allOrderListModalAtom);
  const setAllNotListModal = useSetAtom(allNotAssignListModalAtom);

  const resultDestList = useAtomValue(resultDestListAtom);
  const selectedCarList = useAtomValue(selectedCarListAtom);
  const copyArray = useAtomValue(timeLineChgArrAtom);

  const [carCount, setCarCount] = useState(0);
  const [destCount, setDestCount] = useState(0);
  const [orderCount, setOrderCount] = useState(0);
  const [noShipping, setNoShipping] = useState([]);
  const [calWidth, setCalWidth] = useState('');
  const [topOffset, setTopOffset] = useState('1rem');

  const handleListClick = (type: string) => {
    switch (type) {
      case 'CAR':
        setAllCarListModal(true);
        break;
      case 'DEST':
        setAllDestListModal(true);
        break;
      case 'ORDER':
        setAllOrderListModal(true);
        break;
      case 'NOT':
        setAllNotListModal(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (shippingListCollapse === true && timeLine === true) {
      setCalWidth('70vw');
      setTopOffset('5rem');
    } else if (shippingListCollapse === true && timeLine === false) {
      setCalWidth('320px');
      setTopOffset('1rem');
    } else if (shippingListCollapse === false) {
      setCalWidth('1.6rem');
      setTopOffset('1rem');
    } else {
      setCalWidth('320px');
      setTopOffset('1rem');
    }
  }, [shippingListCollapse, timeLine]);

  useEffect(() => {
    if (resultDestList) {
      const temp: any = [];
      _.forEach(resultDestList, (val) => {
        val.r_car_seq === null && temp.push(val);
      });
      setNoShipping(temp);
    }
  }, [resultDestList]);

  useEffect(() => {
    if (selectedCarList && copyArray && copyArray.length > 0) {
      const tempList: TimeLine[] = selectedCarList.map((item: number) => {
        return _.find(copyArray, ['car.car_seq', item]);
      });
      setCarCount(_.filter(tempList, (v) => v.destLength > 0).length);
      setDestCount(_.sumBy(tempList, 'destLength'));
      setOrderCount(_.sumBy(tempList, 'orderLength'));
    }
  }, [selectedCarList, copyArray]);

  return (
    <MainWrap calWidth={calWidth} topOffset={topOffset} timelineOpen={shippingListCollapse && timeLine}>
      {basicInfo && (
        <>
          <Button
            variant="contained"
            size="large"
            sx={{ background: '#9575CD', width: '9rem' }}
            startIcon={<LocalShippingIcon />}
            onClick={() => handleListClick('CAR')}
          >
            차량 : {carCount}
          </Button>
          <Button
            variant="contained"
            size="large"
            sx={{ background: '#4DB6AC', width: '9rem' }}
            startIcon={<EmojiTransportationIcon />}
            onClick={() => handleListClick('DEST')}
          >
            배송지 : {destCount}
          </Button>
          <Button
            variant="contained"
            size="large"
            sx={{ background: '#FFB74D', width: '9rem' }}
            startIcon={<ListAltIcon />}
            onClick={() => handleListClick('ORDER')}
          >
            주문 : {orderCount}
          </Button>
          <Button
            variant="contained"
            size="large"
            startIcon={<PlaylistRemoveIcon />}
            disabled={noShipping.length === 0}
            sx={{ background: '#A1887F', '&.Mui-disabled': { background: '#aaaaaa' }, width: '9rem' }}
            onClick={() => handleListClick('NOT')}
          >
            미배정 : {noShipping.length}
          </Button>
        </>
      )}
    </MainWrap>
  );
}
